import React, {useMemo} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import IconField from '../IconField';
import {BUTTON_ON, BUTTON_OFF} from '../../constants'

import styles from './AmenitiesSelect.module.scss';

const cx = classnames.bind(styles);

const AmenitiesSelect = ({
  className,
  options,
  multiple = false,
  value,
  onChange
}) => {
  const values = useMemo(function () {
    return multiple ? value.reduce((reducer, el) => ({
      ...reducer,
      [el]: BUTTON_ON
    }), {}) : {[value]: BUTTON_ON};
  }, [value]);

  const onFieldChange = function (newVal, data) {
    const updatedValues = {...values, [data.id]: newVal}
    const result = Object.keys(updatedValues).filter(el => updatedValues[el] === BUTTON_ON)
    onChange(result)
  }

  return (
    <div className={cx('root', className)}>
      {options?.map((option) => (
        <IconField
          key={option.id}
          className={cx('input')}
          data={option}
          value={values[option.id]}
          onChange={onFieldChange}
        />
      ))}
    </div>
  )
}

AmenitiesSelect.propTypes = {
  multiple: PropTypes.bool,
  options: PropTypes.arrayOf(IconField.propTypes.data),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.oneOf([BUTTON_ON, BUTTON_OFF]))
  ])
}

export default AmenitiesSelect;
